import { render, staticRenderFns } from "./tableTitleSetting.vue?vue&type=template&id=6ca30f16&scoped=true&"
import script from "./tableTitleSetting.vue?vue&type=script&lang=js&"
export * from "./tableTitleSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca30f16",
  null
  
)

export default component.exports